import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createStyles, makeStyles } from "@mui/styles";
import classNames from "classnames";
const useStyles = makeStyles(() => createStyles({
    hidden: {
        display: "none",
    },
}));
export const TabPanel = ({ tabValue, position, children, mode = "null", hiddenConainerClassName }) => {
    const classes = useStyles();
    const isActive = tabValue === position;
    if (mode === "null") {
        return isActive ? _jsx(_Fragment, { children: children }) : null;
    }
    const className = classNames([hiddenConainerClassName, { [classes.hidden]: !isActive }]);
    return _jsx("div", { className: className, children: children });
};
//# sourceMappingURL=TabPanel.js.map